import React, { useEffect } from 'react';
import { Box, Container, Typography, Divider, Link } from '@mui/material';
import { useLocation } from 'react-router-dom';

const TermsPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [hash]);

  return (
    <Box sx={{ py: { xs: 3, sm: 4 }, backgroundColor: (t) => t.palette.background.default }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
          Пользовательское соглашение BillingService
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Редакция от: 31 августа 2025 г. • Применимое право: РФ (152-ФЗ и др.)
        </Typography>

        {/* оглавление */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Оглавление
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1 }}>
            {[
              ['#terms', '1. Термины'],
              ['#join', '2. Присоединение'],
              ['#subject', '3. Предмет'],
              ['#account', '4. Регистрация и учетная запись'],
              ['#meters', '5. Данные счетчиков'],
              ['#privacy', '6. Персональные данные'],
              ['#rights', '7. Права и обязанности'],
              ['#limitations', '8. Ограничения'],
              ['#ip', '9. ИС'],
              ['#sla', '10. Ответственность'],
              ['#billing', '11. Оплата'],
              ['#notices', '12. Уведомления'],
              ['#changes', '13. Изменение условий'],
              ['#term', '14. Срок/удаление'],
              ['#law', '15. Право и споры'],
              ['#force', '16. Форс-мажор'],
              ['#misc', '17. Прочее'],
              ['#recs', '18. Рекомендательные технологии'],
            ].map(([href, label]) => (
              <Link key={href} href={href} underline="hover">{label}</Link>
            ))}
          </Box>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* ВСТАВЬ сюда содержимое из канваса.
            Для удобства я проставил id на ключевых разделах ниже — обнови текст разделов
            из документа на канвасе. */}
        <Box component="article" sx={{ '& h4': { mt: 3, mb: 1.25 }, '& p, & li': { lineHeight: 1.75 } }}>
          <Typography id="terms" variant="h4">1. Термины</Typography>
          <Typography>… (перенеси текст из канваса «Термины»)</Typography>

          <Typography id="join" variant="h4">2. Присоединение к Соглашению</Typography>
          <Typography>…</Typography>

          <Typography id="subject" variant="h4">3. Предмет</Typography>
          <Typography>…</Typography>

          <Typography id="account" variant="h4">4. Регистрация и учетная запись</Typography>
          <Typography>…</Typography>

          <Typography id="meters" variant="h4">5. Данные счетчиков и их использование</Typography>
          <Typography>…</Typography>

          <Typography id="privacy" variant="h4">6. Персональные данные и конфиденциальность</Typography>
          <Typography>…</Typography>

          <Typography id="rights" variant="h4">7. Права и обязанности сторон</Typography>
          <Typography>…</Typography>

          <Typography id="limitations" variant="h4">8. Ограничения использования</Typography>
          <Typography>…</Typography>

          <Typography id="ip" variant="h4">9. Интеллектуальная собственность</Typography>
          <Typography>…</Typography>

          <Typography id="sla" variant="h4">10. Уровень сервиса и ответственность</Typography>
          <Typography>…</Typography>

          <Typography id="billing" variant="h4">11. Оплата</Typography>
          <Typography>…</Typography>

          <Typography id="notices" variant="h4">12. Сервисные сообщения и уведомления</Typography>
          <Typography>…</Typography>

          <Typography id="changes" variant="h4">13. Изменение условий</Typography>
          <Typography>…</Typography>

          <Typography id="term" variant="h4">14. Срок действия, прекращение и удаление данных</Typography>
          <Typography>…</Typography>

          <Typography id="law" variant="h4">15. Применимое право и разрешение споров</Typography>
          <Typography>В РФ, с претензионным порядком. …</Typography>

          <Typography id="force" variant="h4">16. Форс-мажор</Typography>
          <Typography>…</Typography>

          <Typography id="misc" variant="h4">17. Прочие условия</Typography>
          <Typography>…</Typography>

          <Typography id="recs" variant="h4">18. Сведения о рекомендательных технологиях</Typography>
          <Typography>…</Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsPage;
